/*!
 * Stimpack Accordion
 *
 * @version : 0.1
 * @author  : Matthias Courville
 */

import { spIsBase64, spBase64Decode } from '../utilities/utilities';

(function(window, document, $, undefined) {
  "use strict";

    var spAccordion = function(el, options)
    {
        var _t = this,
            root = $(el);

        this.o = $.extend({}, {
            maxActiveItems: -1,
        }, options);

        root.on('click', '.sp-accordion-item-trigger', function(e) {

            e.preventDefault();

            var trigger = $(this),
                item = trigger.closest('.sp-accordion-item'),
                itemContent = item.find('> .sp-accordion-item-inner > .sp-accordion-item-body'),
                itemParent = item.parent(),
                activeItems = itemParent.find('> .sp-accordion-item.active');

            if (_t.o.maxActiveItems > 0 && activeItems.length >= _t.o.maxActiveItems)
            {
                activeItems.each(function () {

                    var activeItem = $(this),
                        activeItemContent = activeItem.find('> .sp-accordion-item-inner > .sp-accordion-item-body');

                    if (activeItem[0] != item[0])
                    {
                        activeItem.removeClass('active');
                        activeItemContent.collapse('hide');
                    }
                });
            }

            if (item.hasClass('active'))
            {
                item.removeClass('active');
                itemContent.collapse('hide');
            }
            else
            {
                item.addClass('active');
                itemContent.collapse('show');
            }
        });
    };

    $.fn.spAccordion = function(options)
    {
        options = options || {};

        return this.each(function() {

            var _options = $(this).data('sp-accordion');

            $(this).attr('data-sp-accordion', true);

            if (_options)
            {
                if (typeof _options == 'object')
                {
                    options = $.extend({}, options, _options);
                }
                else if (spIsBase64(_options))
                {
                    options = $.extend({}, options, _options ? JSON.parse(spBase64Decode(_options)) : {});
                }
            }

            this.spAccordion = new spAccordion(this, options);
        });
    };

    $('[data-sp-accordion]').spAccordion();

})(window, document, jQuery);
